import { routerMiddleware } from 'connected-react-router';
import { Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import {
    SET_LITE_TRADE_ACCOUNT_METRICS,
    UPDATE_MARKET_DATA,
    UPDATE_MARKET_DATA_CANDLE
} from "../modules/LiteTrade/liteTradeConstants";
import appHistory from './appHistory';
// Read token
import './token.js';
import { IS_DEV_MODE } from '../config';
import { debugLog } from '../debug';
import { websocketEventMessage } from '../providers/WebSocketProvider/websocketReducer';

const loggerMiddleware: Middleware = ({ getState }) => next => action => {
    const result = next(action);

    if (IS_DEV_MODE) {
        if (
            ![
                SET_LITE_TRADE_ACCOUNT_METRICS,
                UPDATE_MARKET_DATA,
                UPDATE_MARKET_DATA_CANDLE,
                String(websocketEventMessage),
            ].includes(action.type)
        ) {
            debugLog('redux', '%c[Dispatching]', 'color: green', action, getState());
        }
    }

    return result;
};

const postReactNativeMiddleware: Middleware = () => next => action => {
    const result = next(action);
    if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        // чтобы не спамить реакт натив
        if (
            ![
                SET_LITE_TRADE_ACCOUNT_METRICS,
                UPDATE_MARKET_DATA,
                UPDATE_MARKET_DATA_CANDLE,
                String(websocketEventMessage),
            ].includes(action.type)
        ) {
            window.ReactNativeWebView.postMessage(JSON.stringify(action));
        }
    }
    return result;
};

const systemWatchers: Middleware = ({ dispatch }) => {
    // TODO ios not working
    // window.screen.orientation.addEventListener("change", () => windowScreenOrientation(dispatch));
    // windowScreenOrientation(dispatch);

    // window.addEventListener('resize', () => windowResizeHandler(dispatch));
    // windowResizeHandler(dispatch);

    // запускаем событие приложения из реаскта натива (или парент окна)
    if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') { 
        window.addEventListener('message', (nativeEvent) => {
            try {
                const nativeEventData = JSON.parse(nativeEvent?.data);
                if (typeof nativeEventData?.type === 'string') {
                    dispatch(nativeEventData);
                }
            } catch (e) {
                if (IS_DEV_MODE) {
                    console.error(e);
                }
            }
        });
    } 

    document.addEventListener('visibilitychange', (payload) => {
        dispatch({
            type: 'VISIBILITY_CHANGE',
            payload,
        });
    });

    return next => action => next(action);
};

// const windowResizeHandler = debounce(dispatch => {
//     dispatch({
//         type: 'WINDOW_RESIZE',
//         payload: {
//             width: window.innerWidth,
//             height: window.innerHeight,
//         },
//     });
// }, 250);

export const sagaMiddleware = createSagaMiddleware();

const reactRouterMiddleware: Middleware = routerMiddleware(appHistory);

const middlewares: Middleware[] = [
    reactRouterMiddleware,
    systemWatchers,
    sagaMiddleware,
    loggerMiddleware,
    postReactNativeMiddleware,
];

export default middlewares;
